import { render, staticRenderFns } from "./MainInputCheckboxGroup.vue?vue&type=template&id=4fa348ae&scoped=true"
import script from "./MainInputCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./MainInputCheckboxGroup.vue?vue&type=script&lang=js"
import style0 from "./MainInputCheckboxGroup.vue?vue&type=style&index=0&id=4fa348ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa348ae",
  null
  
)

export default component.exports